import { css } from "styled-components";
export const spinner = css([".ant-spin{color:", ";&-dot-item{background-color:", ";}}"], p => p.theme.colors.primary.base, p => p.theme.colors.primary.base);